import React, { useState, useEffect } from 'react';
import { colors } from '../../../../../styleSheet';
import { Typography, Box, Divider, Modal } from '@mui/material';
import LineGraph from '../../LineGraph';
import { useParams } from 'react-router-dom';
import Revisions from '../../../../../redux/containers/pipelineMonitoring/Revisions';

import ServiceAlert from '../../../ServiceAlert';
import ServiceHeader from '../Node/ServiceHeader';
import { DrawerEmpty } from '../Node/DrawerStates';
import TimeframeChips from '../TimeframeChips';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  bgcolor: 'background.paper',
  border: `2px solid ${colors.black}`,
  boxShadow: 24,
  p: 4,
  zIndex: 100,
};

function MetricsInfo(props) {
  const {
    edge,
    getTasksDepth,
    tasksDepth,
    loadingTasksDepth,
    getTasksCount,
    tasksCount,
    loadingTasksCount,
    navigationOptions,
  } = props;

  const { session, date } = useParams();
  const [timeFrame, setTimeFrame] = useState(2);
  const [selectedGraph, setSelectedGraph] = useState(false);
  const [newPolicy, setNewPolicy] = useState(false);

  const header = (
    <ServiceHeader
      title={edge.data.child.cloud_tasks_queue}
      subtitle={`${edge.data.child.display_name ?? ''}${
        edge.data.child.description ? ` — ${edge.data.child.description}` : ''
      }`}
    />
  );

  useEffect(() => {
    getTasksDepth({
      metrics_type: 'cloud_tasks_depth',
      hours: timeFrame,
      is_vertex: edge.data.child.is_vertex,
      service_name: edge.data.child.cloud_tasks_queue,
      project_id: edge.data.child.queue_project_id,
    });

    getTasksCount({
      metrics_type: 'cloud_tasks_count',
      hours: timeFrame,
      is_vertex: edge.data.child.is_vertex,
      service_name: edge.data.child.cloud_tasks_queue,
      project_id: edge.data.child.queue_project_id,
    });
  }, [timeFrame, newPolicy]);

  if (!tasksDepth && !tasksCount) {
    return (
      <Box>
        {header}
        <DrawerEmpty>No metrics available for this service...</DrawerEmpty>
      </Box>
    );
  }
  return (
    <Box>
      {edge.data.alerts?.map((alertInfo) => {
        return (
          <Box sx={{ marginX: 1 }}>
            <ServiceAlert alertInfo={alertInfo} />
          </Box>
        );
      })}
      {header}
      <TimeframeChips timeFrame={timeFrame} setTimeFrame={setTimeFrame} />
      <Modal
        style={{ backdropFilter: 'blur(5px)' }}
        open={selectedGraph !== false}
        onClose={() => setSelectedGraph(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ fontWeight: 'bold' }}
          >
            {selectedGraph ? selectedGraph.title : null}
          </Typography>
          <Box sx={{ width: '800px', height: '500px' }}>
            <LineGraph
              data={selectedGraph.data}
              size="lg"
              graphType={selectedGraph.type}
            />
          </Box>
        </Box>
      </Modal>
      <Box sx={{ margin: 2, backgroundColor: colors.lavender, borderRadius: 1 }}>
        <Revisions
          data={tasksDepth}
          loadingData={loadingTasksDepth}
          setSelectedGraph={setSelectedGraph}
          title="Tasks Queue Depth"
          selectedRevision={'Cloud Tasks'}
          graphType={'numerical'}
          newPolicy={newPolicy}
          setNewPolicy={setNewPolicy}
          navOptions={navigationOptions}
          metric={{
            project_id: edge.data.child.queue_project_id,
            resource_type: 'cloud_tasks_queue',
            metric_type: 'cloudtasks.googleapis.com/queue/depth',
            resource_label_key: 'queue_id',
            resource_label_value: edge.data.child.cloud_tasks_queue,
          }}
        />
        <Divider sx={{ borderBottomWidth: 2 }} />
        <Revisions
          data={tasksCount}
          loadingData={loadingTasksCount}
          setSelectedGraph={setSelectedGraph}
          title="Tasks Attempt Count"
          selectedRevision={'Cloud Tasks'}
          graphType={'numerical'}
          newPolicy={newPolicy}
          setNewPolicy={setNewPolicy}
          navOptions={navigationOptions}
          metric={{
            project_id: edge.data.child.queue_project_id,
            resource_type: 'cloud_tasks_queue',
            metric_type: 'cloudtasks.googleapis.com/queue/task_attempt_count',
            resource_label_key: 'queue_id',
            resource_label_value: edge.data.child.cloud_tasks_queue,
          }}
        />
      </Box>
    </Box>
  );
}

export default MetricsInfo;
